import cn from 'classnames';
import styles from './configurator-filter-menu.module.scss';

interface ItemProps {
  readonly label: string;
  readonly state?: 'inactive' | 'active';
  readonly onClick?: React.MouseEventHandler;
}

const Item: React.FC<React.PropsWithChildren<ItemProps>> = ({
  label,
  state,
  onClick,
}) => {
  return (
    <li
      className={cn(styles.item, { [styles.isActive]: state === 'active' })}
      onClick={onClick}
    >
      {label}
    </li>
  );
};

interface ConfiguratorFilterMenuElementProps {
  readonly className?: string;
}

const ConfiguratorFilterMenuElement: React.FC<
  React.PropsWithChildren<ConfiguratorFilterMenuElementProps>
> = ({ children, className }) => {
  return (
    <nav className={cn(styles.container, className)}>
      <ul className={styles.itemList}>{children}</ul>
    </nav>
  );
};

const ConfiguratorFilterMenu = Object.assign(ConfiguratorFilterMenuElement, {
  Item,
});

export default ConfiguratorFilterMenu;
